import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import NRReachableComponentIcon from '../../NRIcons/NRReachableComponentIcon';

export function nrReachabilityInlineLinkButtonSx(theme) {
  return {
    border: 'none',
    background: 'none',
    padding: 0,
    margin: 0,
    font: 'inherit',
    color: 'inherit',
    textDecoration: 'underline',
    cursor: 'pointer',
    display: 'inline',
    verticalAlign: 'baseline',
    '&:focus-visible': {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2
    }
  };
}

/**
 * Warning alert with an inline button that scrolls/focuses the reachability evidence section.
 * Optional `sx` and `iconColor` allow callers (e.g. SBOM drawer) to override surface styling without affecting other surfaces.
 */
function NRReachabilityAlert({
  beforeText,
  linkText = 'Reachable',
  afterText,
  linkAriaLabel,
  onScrollToEvidence,
  sx: sxProp,
  iconColor,
  severity = 'warning'
}) {
  const theme = useTheme();
  const inlineSx = nrReachabilityInlineLinkButtonSx(theme);
  const defaultSx = { mb: theme.spacing(3), height: theme.spacing(5), alignItems: 'center' };
  const mergedSx = typeof sxProp === 'function' ? [defaultSx, sxProp(theme)] : sxProp ? [defaultSx, sxProp] : defaultSx;
  return (
    <Alert icon={iconColor != null ? <NRReachableComponentIcon color={iconColor} /> : <NRReachableComponentIcon />} severity={severity} sx={mergedSx}>
      <span>
        {beforeText}
        <Box component="button" type="button" sx={inlineSx} aria-label={linkAriaLabel} onClick={onScrollToEvidence}>
          {linkText}
        </Box>
        {afterText}
      </span>
    </Alert>
  );
}

export default NRReachabilityAlert;
